import { t } from '@lingui/macro';
export const yesNoFilterOptions = [
    { id: 'true', title: t({ message: 'Yes', comment: 'Boolean filter: Yes' }) },
    { id: 'false', title: t({ message: 'No', comment: 'Boolean filter: No' }) },
];
